<template>
    <div class="img-picker-loading">
        <v-spinner status="default" size="large"></v-spinner>
    </div>
</template>

<script>
export default {
    name: 'ReplyLoading'
};
</script>

<style scoped>
.img-picker-loading {
    position: absolute;
    top: 40%;
    right: 0;
    left: 0;
    text-align: center;
    z-index: 9;
}
</style>
